/**
 * Application Configuration
 * Contains OAuth client and Cognito configurations
 */

export interface ClientConfig {
  name: string
  allowedHostnames: string[]
}

// Cognito configuration constants
export const COGNITO_CONFIG = {
  region: process.env.AWS_REGION || 'us-east-1',
  userPoolId: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID || 'us-east-1_fuctdjppH',
  clientId: process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID || '1dj03qvru0s20adbt2f9njl499',
  clientSecret: process.env.COGNITO_CLIENT_SECRET, // Optional - only if app client has secret
  get userPoolDomain () {
    return `https://${this.userPoolId.replace('_', '')}.auth.${this.region}.amazoncognito.com`
  },
  get domain () {
    return `https://cognito-idp.${this.region}.amazonaws.com`
  },
} as const

export const DEFAULT_CLIENT_ID = '1dj03qvru0s20adbt2f9njl499' as const

// Client configurations with allowed hostname patterns
export const CLIENT_CONFIGS: Record<string, ClientConfig> = {
  '58s6rbd61mkog80c08cev8vri7': {
    name: 'MapQuest (Legacy)',
    allowedHostnames: [
      'localhost',
      'localhost:*',
      '*.mapquest.com',
    ],
  },
  '1dj03qvru0s20adbt2f9njl499': {
    name: 'MapQuest',
    allowedHostnames: [
      'localhost',
      'localhost:*',
      '*.mapquest.com',
    ],
  },
} as const
